export default __webpack_public_path__ + "static/logo-891b55484bd080488bbf81cb2fe2e1a8.svg";